module.exports = __webpack_public_path__ + "img/logo.5289a813.png";